import { queryOptions } from "@tanstack/react-query";

import { useApi } from "@/api/hooks/useApi";
import { commonAPIDataSelector } from "@/helpers/Network/selectors";
import { useProjectId } from "@/hooks/Network/useProjectId";
import { QUERY_KEYS } from "@/query-keys";

export const usePlusButtonQueries = () => {
  const api = useApi();
  const projectId = useProjectId();

  return {
    list: () =>
      queryOptions({
        queryKey: QUERY_KEYS.PLUS_BUTTON_OPTIONS_LIST(projectId),
        queryFn: () => api.getFastActionItemsV1(),
        select: commonAPIDataSelector,
      }),
  };
};
